import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import {
  type FontFamilyId,
  type FontSizeId,
  DEFAULT_FONT_FAMILY,
  DEFAULT_FONT_SIZE,
} from '@/shared/constants/fonts';

interface FontPrefsStore {
  fontFamily: FontFamilyId;
  fontSize: FontSizeId;
  setFontFamily: (id: FontFamilyId) => void;
  setFontSize: (id: FontSizeId) => void;
  reset: () => void;
}

export const useFontPrefsStore = create<FontPrefsStore>()(
  persist(
    (set) => ({
      fontFamily: DEFAULT_FONT_FAMILY,
      fontSize: DEFAULT_FONT_SIZE,
      setFontFamily: (id) => set({ fontFamily: id }),
      setFontSize: (id) => set({ fontSize: id }),
      reset: () => set({ fontFamily: DEFAULT_FONT_FAMILY, fontSize: DEFAULT_FONT_SIZE }),
    }),
    {
      name: 'sf-font-prefs',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined'
          ? localStorage
          : ({ getItem: () => null, setItem: () => {}, removeItem: () => {} } as Storage),
      ),
      partialize: (state) => ({ fontFamily: state.fontFamily, fontSize: state.fontSize }),
    },
  ),
);
